import { makeStyles } from 'tss-react/mui';
import { colors } from '../../styles/jss/variables';
const useStyles = makeStyles()((theme, _params, classes) => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        position: 'relative',
        '& video::-webkit-media-controls-fullscreen-button': {
            display: 'none',
        },
        '& video::-webkit-media-controls-play-button': {
            display: 'none',
        },
    },
    icon: {
        fontSize: `100px`,
    },
    controlsContainer: {
        backgroundColor: 'transparent',
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 10,
        [`& .${classes.icon}`]: {
            fontSize: '6.25rem',
            color: colors.supplementary.white,
            cursor: 'pointer',
            marginRight: 0,
            '& span': {
                fontSize: 'inherit',
            },
        },
    },
    videoContainerSection: {
        position: (_params === null || _params === void 0 ? void 0 : _params.isFromContentFeature) ? 'absolute' : 'relative',
        top: (_params === null || _params === void 0 ? void 0 : _params.isFromContentFeature) ? 0 : 'auto',
        left: (_params === null || _params === void 0 ? void 0 : _params.isFromContentFeature) ? 0 : 'auto',
        width: '100%',
        height: (_params === null || _params === void 0 ? void 0 : _params.isFromContentFeature) ? '100%' : 'auto',
        minHeight: (_params === null || _params === void 0 ? void 0 : _params.isFromContentFeature) ? 'unset' : '200px',
        cursor: 'pointer',
        border: 'none',
        padding: 0,
        margin: 0,
        background: 'transparent',
        aspectRatio: (_params === null || _params === void 0 ? void 0 : _params.isFromContentFeature) ? 'unset' : '16/9',
        overflow: 'hidden',
        contain: (_params === null || _params === void 0 ? void 0 : _params.isPortrait) ? 'layout style' : 'strict',
        isolation: 'isolate',
        transform: 'translateZ(0)',
        // Ensure it never escapes parent
        maxWidth: '100%',
        maxHeight: '100%',
    },
    containerHoverOverlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 5,
        backgroundColor: 'transparent',
        cursor: 'pointer',
        border: 'none',
        padding: 0,
        margin: 0,
    },
    videoContainerElement: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        objectFit: (_params === null || _params === void 0 ? void 0 : _params.isPortrait) ? 'contain' : 'cover',
        objectPosition: 'center',
        zIndex: 1,
        background: 'transparent',
    },
    posterThumbnail: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        objectFit: (_params === null || _params === void 0 ? void 0 : _params.isPortrait) ? 'contain' : 'cover',
        objectPosition: 'center',
        zIndex: 1,
        backgroundColor: (_params === null || _params === void 0 ? void 0 : _params.isPortrait) ? 'transparent' : colors.supplementary.black,
    },
    loadingPlaceholder: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'transparent',
        zIndex: 1,
        // No visible loader - just maintain space
        pointerEvents: 'none',
    },
    posterThumbnailInlineSytles: {
        width: '100%',
        height: '100%',
        objectFit: (_params === null || _params === void 0 ? void 0 : _params.isPortrait) ? 'contain' : 'cover',
        display: 'block',
    },
    videoContainerInlineStyles: {
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        objectFit: (_params === null || _params === void 0 ? void 0 : _params.isPortrait) ? 'contain' : 'cover',
    },
    portraitBlurredBg: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 0,
        overflow: 'hidden',
        visibility: (_params === null || _params === void 0 ? void 0 : _params.isPortrait) ? 'visible' : 'hidden',
        backgroundColor: colors.supplementary.black, // Fallback while image loads
        '& img': {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            filter: 'blur(20px) brightness(0.7)',
            // Scale up slightly to hide blur edges
            scale: '1.1',
        },
    },
}));
export default useStyles;
